import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppGlobals } from '@app/app.global';
import { OrdersResponse, InvoiceUrlResponse } from '@modules/hyperpure/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SwiggyOrderService {

  constructor(private http: HttpClient, private appGlobals: AppGlobals) { }

  private entityHeaders(entityId?: string) {
    return entityId ? { 'x-entity-ids': entityId } : {};
  }

  getOrders(params: {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
    status?: string;
    entityId?: string;
  }): Observable<OrdersResponse> {
    let httpParams = new HttpParams();
    const entityId = params.entityId;

    Object.keys(params).forEach(key => {
      if (key === 'entityId') {
        return;
      }
      const value = params[key as keyof typeof params];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http.get<OrdersResponse>(
      `${this.appGlobals.apiUrl.dashboard}/swiggy/orders`,
      { params: httpParams, headers: this.entityHeaders(entityId) }
    );
  }

  getInvoiceSignedUrl(orderNumber: string, download: boolean = false, entityId?: string): Observable<InvoiceUrlResponse> {
    let params = new HttpParams();
    if (download) {
      params = params.set('download', 'true');
    }
    return this.http.get<InvoiceUrlResponse>(
      `${this.appGlobals.apiUrl.dashboard}/swiggy/orders/${orderNumber}/invoice`,
      { params, headers: this.entityHeaders(entityId) }
    );
  }
}
